export const SET_ELECTION_INCIDENT_COUNTS_BY_STATUS = 'SET_ELECTION_INCIDENT_COUNTS_BY_STATUS';

export const setElectionIncidentCountsByStatus = (incidentCounts: any) => (dispatch: any) => {
  dispatch({ type: SET_ELECTION_INCIDENT_COUNTS_BY_STATUS, payload: incidentCounts });
};
